export class Company {
    companyId: string
    companyName: string
    email: string
    status: number
    timezone: number
    owner: string
    planExpiresAt: Date
    planGraceDays: number
    planAlertDismiss?: Date
    planStatus: 'active' | 'blocked' | 'canceled' | 'manual' | 'overdue' | 'trial' | 'renew' | 'blocked_trial' | 'free'
    // espelha purchase.purchaseMethod da assinatura no payments-api (users-api: companies.service)
    planMethod?: 'bankslip' | 'credit' | 'pix'
    planPurchaseId?: string
    planPastDueDays?: number
    planForceChargeAlert: boolean
    planConfidenceUnlock?: Date
    // data em que o acesso termina porque a assinatura foi cancelada no payments-api. Calculada pela
    // users-api (syncPayment): já considera o período pago. Chegada a data, a empresa vira canceled.
    planAccessEndsAt?: Date
    planRenewDelayed?: number
    planRenewDelayedAt?: Date

    city?: string
    state?: string
    street?: string
    addressNumber?: string
    addressComplement?: string
    neighborhood?: string
    zipCode?: string
    phone?: string
    logo?: string
    icon?: string
    companyLegalName?: string
    document?: string
    appVersion?: string
    managerId?: string
}

export class AllowedHoursEntity {
    constructor() {
        this.active = false
        this.interval = []
        for (let index = 0; index < 7; index++) {
            this.interval.push({
                fromTime: 0,
                toTime: 1439,
                weekDay: index,
            })
        }
    }
    active: boolean
    interval: AllowedHoursIntervalEntity[]
}

export class AllowedHoursIntervalEntity {
    weekDay: number
    fromTime: number
    toTime: number
}
